import { UnfoldMoreIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const ChevronsUpDown = /* @__PURE__ */ createIcon(UnfoldMoreIcon, 'ChevronsUpDown');
